export const sortLeaguesByOrderId = (x, y) => x.defaultOrder - y.defaultOrder;
//# sourceMappingURL=sortLeaguesByOrderId.js.map